import React, {useState} from "react";
import {AiOutlineClose} from 'react-icons/ai';
import '../../css/ManagerPage.css'

const ManagerModal =({upLoad, onFileChange, setNewItem, newItem, setModalList,setSubFile,text,setText,addOption,setAddOption})=>{
    const [imgUrl,setImgUrl]=useState();
    const [subImgUrl,setSubImgUrl]=useState();
    const [loading,setLoading]=useState(false);


    return(
        <>
            {
                !loading?
                    <div className={'manager-modal-container scroll-auto'}>
                        <div className={'manager-modal-close-box'}>
                            <AiOutlineClose size={20} style={{cursor:'pointer'}} onClick={()=>setModalList(0)}/>
                        </div>
                        {
                            imgUrl&&
                            <div className={'manager-modal-img-box'}>
                                <img src={imgUrl} alt={'img'} width={100} height={100}/>
                            </div>
                        }
                        <div className={'manager-modal-item-box'}>
                            <div className={'flex__center'}>
                                <div className={'flex__low manager-modal-input'}>
                                    <label>제목: </label>
                                    <input type='text' placeholder={'title'} onChange={(e)=>{setNewItem({...newItem, name: e.target.value})}}/>
                                </div>
                                <div className={'flex__low manager-modal-input'}>
                                    <label>가격:</label>
                                    <input type='text' placeholder={'price'} onChange={(e)=>{setNewItem({...newItem, price: e.target.value})}}/>
                                </div>
                            </div>
                            <div className={'flex__center align__left'}>
                                <div className={'flex__low manager-modal-input'}>
                                    <label>메인 이미지</label>
                                    <input type="file" accept="image/*" onChange={(e)=> {
                                        onFileChange(e);
                                        setImgUrl(URL.createObjectURL(e.target.files[0]))
                                    }}/>
                                </div>
                                <div className={'flex__low manager-modal-input'}>
                                    <label>디테일 이미지</label>
                                    <input type="file" accept="image/*" onChange={(e)=> {
                                        setSubFile(e.target.files[0]);
                                        setSubImgUrl(URL.createObjectURL(e.target.files[0]));
                                    }}/>
                                </div>
                                {
                                    subImgUrl&&
                                    <div className={'manager-modal-img-box'}>
                                        <img src={subImgUrl} alt={'sub-img'} width={'100%'}/>
                                    </div>
                                }
                                <div className={'flex__low align__left manager-modal-input'}>
                                    <label>상품설명</label>
                                    <textarea onChange={e => setText(e.target.value)} value={text}/>
                                </div>
                                <div className={'flex__low align__left manager-modal-input'}>
                                    <label onClick={()=>{
                                        setAddOption([...addOption,{id:Date.now(),value:""}]);
                                        console.log(addOption)
                                    }}>종류 추가하기</label>
                                    <div className={'manager-modal-add-option'}>
                                        {
                                            addOption&&
                                            addOption.map((item)=>(
                                                <input key={item.id} type={'text'} onChange={(e)=>{
                                                    setAddOption(addOption.map(item2=>item2.id===item.id?({...item2,value:e.target.value}):({...item2})));
                                                    console.log(addOption)
                                                }} value={item.value}/>
                                            ))
                                        }
                                    </div>
                                </div>
                                <div className={'flex__center manager-modal-upload'}>
                                    <button onClick={()=>{
                                        if(newItem.name&&newItem.price&&imgUrl&&subImgUrl){
                                            setLoading(true);
                                            upLoad();
                                        }else{
                                            alert("폼을 다시 확인 해주세요")
                                        }

                                    }}>업로드하기</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <div className={'manager-modal-container scroll-auto flex__center'}>
                        <a>업로드 중입니다...</a>
                        <a>잠시 기다려주세요...</a>
                        <a>업로드가 완료되면 자동으로 새로고침 됩니다.</a>
                    </div>
            }

        </>
    );
};
export default ManagerModal;
